function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
//
import * as React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from "../../../styles/theme";
var styles = StyleSheet.create({
  BreadcrumbItem: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center'
  }
});
export default function BreadcrumbItem(_ref) {
  var _ref$htmlAttributes = _ref.htmlAttributes,
    htmlAttributes = _ref$htmlAttributes === void 0 ? {} : _ref$htmlAttributes,
    _ref$rootClassName = _ref.rootClassName,
    rootClassName = _ref$rootClassName === void 0 ? '' : _ref$rootClassName,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    children = _ref.children,
    isCurrentPage = _ref.isCurrentPage,
    hideSeparator = _ref.hideSeparator,
    href = _ref.href,
    _ref$linkClassName = _ref.linkClassName,
    linkClassName = _ref$linkClassName === void 0 ? '' : _ref$linkClassName,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? '/' : _ref$separator,
    _ref$separatorClassNa = _ref.separatorClassName,
    separatorClassName = _ref$separatorClassNa === void 0 ? '' : _ref$separatorClassNa;
  if (!children) {
    return null;
  }
  var link;
  if (href) {
    link = /*#__PURE__*/React.createElement("a", _extends({}, css(linkClassName, styles.link), {
      href: href,
      "aria-current": isCurrentPage ? 'page' : null
    }), children);
  } else {
    link = children;
  }
  if (children) {
    return /*#__PURE__*/React.createElement("div", _extends({}, css(rootClassName, styles.BreadcrumbItem), htmlAttributes, {
      style: style,
      "aria-current": isCurrentPage ? 'page' : null
    }), link, !hideSeparator && /*#__PURE__*/React.createElement("span", {
      className: separatorClassName,
      "aria-hidden": true
    }, separator));
  }
}
BreadcrumbItem.defaultProps = {
  htmlAttributes: {},
  rootClassName: '',
  style: {},
  linkClassName: '',
  separator: '/',
  separatorClassName: ''
};
BreadcrumbItem.propTypes = {
  htmlAttributes: PropTypes.object,
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
  children: PropTypes.node,
  href: PropTypes.string,
  linkClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  separator: PropTypes.node,
  separatorClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hideSeparator: PropTypes.bool
};